const setCustomStyle = (item) => {
    let customStyle = {};
    if (item.color !== '') {
        customStyle.color = `#${item.color}`;
    }
    if (item.backgroundColor !== '') {
        customStyle.backgroundColor = `#${item.backgroundColor}`;
    }
    customStyle.maxWidth = document.body.clientWidth + 'px';
    return customStyle;
};

export default setCustomStyle;
